<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="payInfo">
    <PlateTitle title="投保信息" />
    <div class="main">
      <a-form :label-col="{ span: 10 }" :wrapper-col="{ span: 12}">
        <a-row>
          <a-col :span="12">
            <a-form-item label="业务流水号" has-feedback>
              <span>{{ infoJson.orderCode }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="投标企业名称" has-feedback>
              <span>{{ infoJson.enterpriseName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="投标企业社会信用代码" has-feedback>
              <span>{{ infoJson.creditCode }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="担保保额(元)" has-feedback>
              <span>{{ infoJson.sumAmount }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="担保保费(元)" has-feedback>
              <span>{{ infoJson.sumPremium }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <PlateTitle title="收款信息" />
    <div class="main">
      <a-form :label-col="{ span: 10 }" :wrapper-col="{ span: 12}">
        <a-row>
          <a-col :span="12">
            <a-form-item label="开户行" has-feedback>
              <span>{{ infoJson.receiveBankName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收款开户名称" has-feedback>
              <span>{{ infoJson.receiveAccountName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="开户账号" has-feedback>
              <span>{{ infoJson.receiveAccountNo }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金额(元)" has-feedback>
              <span>{{ infoJson.sumPremium }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <PlateTitle title="上传打款凭证" />
    <div class="main">
      <div class="upload">
        <a-upload
          name="file"
          :maxCount="1"
          :action="uploadAction"
          :beforeUpload="beforeUpload"
          @change="handleChange"
        >
          <a-button> <a-icon type="upload" /> 上传文件 </a-button>
        </a-upload>
        <div class="limt">(支持jpg、png格式文件，文件不能大于5M)</div>
        <div class="tips">
          <p>1.对公打款流水号确认无误后，请点击确认提交</p>
          <p>2.打款时请务必在“备注”“用途”或者“摘要”中注明投标工程项目名称</p>
        </div>
      </div>
    </div>
    <div v-if="isShow" class="submitBtn" @click="submitFun">确认提交</div>
    <div v-else class="gry" >支付审核中....</div>
  </div>
</template>
<script>
import PlateTitle from "@/components/PlateTitle";
import { getPaymentInfo, offlinePost } from "./api.js";
import UloadBtn from "@/components/UploadBtn/uloadBtn.vue";
export default {
  components: {
    PlateTitle,
    UloadBtn
  },
  data() {
    return {
      infoJson: {},
      orderNo: "",
      fileData: [],
      uploadAction: process.env.VUE_APP_FIRST_URL + '/api/contract/upload',
      fileInfo:{},
      isShow: false
    };
  },
  mounted() {
    this.init();
    this.orderNo = this.getQueryString("orderNo");
  },
  methods: {
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传 JPG/PNG 格式的文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 5MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    handleChange(info) {
      if (info.file.status !== 'uploading') {}
      if (info.file.status === 'done') {
        this.$message.success(`文件上传成功`);
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败`);
      }
      console.log(info, 999)
      this.fileData = info.fileList
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    async init() {
      this.orderNo = this.getQueryString("orderNo");
      const { data: data } = await getPaymentInfo({
        orderNo: this.orderNo,
        platformType: 4,
      });
      this.infoJson = data.data;
      if(this.infoJson.vouchStatus === "1") {
        this.isShow = false
      }
      if(this.infoJson.vouchStatus === "0" || this.infoJson.vouchStatus === "3") {
        this.isShow = true
      }
      if(this.infoJson.vouchStatus === "2") {
        window.location.href = this.infoJson.backUrl;
      }
    },
    submitFun() {
      if(this.fileData.length === 0) {
        this.$message.error(`请上传打款凭证`);
      } else {
        const data = {
          orderCode: this.orderNo,
          fileInfo: this.fileData[0].response.data
        }
        offlinePost(data).then((res) => {
          if (res.data.status == 200) {
            window.location.href = this.infoJson.backUrl;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.payInfo {
  width: 1200px;
  min-height: 700px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 124, 226, 0.03);
  border-radius: 2px 2px 2px 2px;
  margin: auto;
  margin-top: 24px;
  padding: 40px 30px 40px 30px;
  .subtitle {
    font-size: 14px;
    line-height: 28px;
  }
  ::v-deep .ant-form-item-label {
    width: 192px;
    padding-left: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-right: 10px;
  }
  ::v-deep .ant-form-item-children {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  /deep/ .ant-form-item {
    margin-bottom: 10px !important;
  }
  .main {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .pay_info {
    display: flex;
    margin-left: 80px;
    .info_box {
      width: 380px;
      height: 400px;
      background: #ffffff;
      box-shadow: 5px 15px 30px 5px rgba(75, 111, 158, 0.15);
      border-radius: 5px 5px 5px 5px;
      margin-right: 20px;
      cursor: pointer;
      .head_s {
        padding-top: 40px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .logo {
        margin: auto;
        width: 150px;
        height: 150px;
        margin-top: 33px;
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
    .pay {
      display: flex;
      width: 160px;
      height: 60px;
      border: 1px solid #ccc;
      border-radius: 8px;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      .payImg {
        width: 120px;
        height: 40px;
        position: relative;
        top: 10px;
        left: 15px;
      }
      .choose {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 3px;
        right: 3px;
        z-index: 2;
      }
    }
    .active {
      border-color: #0E52D4;
    }
  }
  .submitBtn {
    width: 160px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #0E52D4;
    color: #ffffff;
    border-radius: 5px;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .gry {
    width: 160px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #28292a;
    color: #ffffff;
    border-radius: 5px;
    margin: 40px auto 0;
  }
  .upload {
    width: 500px;
    margin: 30px auto 0;
    position: relative;
  }
  .tips {
    margin-top: 30px;
    p {
      color: #333;
      font-size: 12px;
    }
  }
  .limt {
    position: absolute;
    top: 7px;
    left: 120px;
    font-size: 12px;
  }
}
.wxTips {
  color: red;
  padding: 30px;
}
</style>
